import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import MedRouteForm from './MedRouteForm';

const EditMedRouteModal = ({ show, onHide, routevalue, medroutevalue, edittrigger, onCallParent }) => {
    const val = routevalue || medroutevalue;
    const isEdit = Boolean(val && (val.route_id || val.id));

    const handleSuccess = () => {
        if (onCallParent) onCallParent();
        if (onHide) onHide();
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title as="h5">
                    {isEdit ? 'Edit Route' : 'Add Route'}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <MedRouteForm
                    edittrigger={edittrigger}
                    onCallParent={handleSuccess}
                    routevalue={val}
                    medroutevalue={val}
                />
            </Modal.Body>
        </Modal>
    );
};

EditMedRouteModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    routevalue: PropTypes.any,
    medroutevalue: PropTypes.any,
    edittrigger: PropTypes.number,
    onCallParent: PropTypes.func
};

export default EditMedRouteModal;
